<script>
  import * as restfulService from '../../../../../services/restfulService'
  import dataService from '../../../../../services/dataService'
  import * as MESSAGES from '../../../../../messages'

  import bus from '@utils/bus'
  import helpers from '@mixins/helper'
  import {mapGetters, mapActions} from 'vuex'

  import {clone, cloneDeep} from 'lodash'
  import {required, requiredIf} from 'vuelidate/lib/validators'

  const necessidadeObj = {
    id: null,
    ref_pessoa: null,
    ref_necessidade_especial: null,
    necessidade_especial_compl: '',
    fl_permanente: false,
    fl_dificil_acesso: false,
    fl_necessita_acompanhamento: false
  }

  export default {
    mixins: [helpers],
    props: ['dados'],
    data () {
      return {
        botaoClicado: false,
        data: {
          necessidades_especiais: [],
          necessidade: Object.assign({}, necessidadeObj)
        },
        dependencias: {
          necessidades_especiais: []
        }
      }
    },
    validations: {
      data: {
        necessidade: {
          ref_necessidade_especial: {required},
          necessidade_especial_compl: {
            required: requiredIf(function () {
              let necessidadeEspecial = this.dependencias.necessidades_especiais.find(item => item.id === this.data.necessidade.ref_necessidade_especial)
              return necessidadeEspecial && necessidadeEspecial.fl_exige_compl
            })
          }
        }
      }
    },
    computed: {
      ...mapGetters(['currentUser']),
      necessidadeEspecialErros () {
        const erros = []
        if (!this.$v.data.necessidade.ref_necessidade_especial.$dirty) return erros
        !this.$v.data.necessidade.ref_necessidade_especial.required && erros.push(MESSAGES.VALIDATION_REQUIRED)
        return erros
      },
      necessidadeEspecialComplementoErros () {
        const erros = []
        if (!this.$v.data.necessidade.necessidade_especial_compl.$dirty) return erros
        !this.$v.data.necessidade.necessidade_especial_compl.required && erros.push(MESSAGES.VALIDATION_REQUIRED)
        return erros
      }
    },
    mounted () {
      this.getDependencies().then(() => {
        this.data.necessidades_especiais.splice(0)
        this.data.necessidades_especiais = [...this.data.necessidades_especiais, ...this.dados.pessoa.necessidades_especiais]
      })
    },
    methods: {
      ...mapActions(['showNotification']),
      getDependencies () {
        return new Promise(resolve => {
          dataService.get([
            {domain: 'necessidade_especial'}
          ]).then((result) => {
            this.dependencias = {...this.dependencias, ...result}
            resolve()
          })
        })
      },
      editarNecessidadeEspecial (item) {
        this.data.necessidade = cloneDeep(item)
      },
      limparNecessidadeEspecial () {
        this.data.necessidade = Object.assign({}, necessidadeObj)
        this.$v.data.necessidade.$reset()
      },
      salvarNecessidadeEspecial () {
        this.botaoClicado = true
        bus.$emit('show-loader')
        let data = clone(this.data.necessidade)
        if (!data.ref_pessoa) {
          data.ref_pessoa = this.currentUser.ref_pessoa
        }
        restfulService.save('pessoa_necessidade_especial', null, null, data)
          .then(response => {
            this.showNotification({
              message: 'Seus dados foram salvos'
            })
            if (data.id) {
              this.data.necessidades_especiais = this.data.necessidades_especiais.filter(obj => obj.id !== data.id)
            }
            let necessidadeEspecialSelecionada = this.dependencias.necessidades_especiais.find(item => item.id === response.ref_necessidade_especial)
            let necessisadadeEspecialSave = response
            necessisadadeEspecialSave.necessidade_especial = necessidadeEspecialSelecionada
            this.data.necessidades_especiais.push(necessisadadeEspecialSave)
            this.limparNecessidadeEspecial()
            this.botaoClicado = false
            bus.$emit('hide-loader')
          })
          .catch(e => {
            this.botaoClicado = false
            bus.$emit('hide-loader')
            console.log(e)
          })
      },
      removerNecessidadeEspecial (item) {
        bus.$emit('show-loader')
        restfulService.destroy('pessoa_necessidade_especial', null, item.id)
          .then(() => {
            this.showNotification({
              title: 'Dados excluídos',
              message: 'Os dados foram removidos'
            })
            this.data.necessidades_especiais = this.data.necessidades_especiais.filter(obj => obj.id !== item.id)
            bus.$emit('hide-loader')
          })
          .catch(e => {
            bus.$emit('hide-loader')
            console.log(e)
          })
      }
    }
  }
</script>

<template>
    <v-form>
        <v-container fluid grid-list-md>
            <v-layout row wrap>
                <v-flex sm6 xs12>
                    <v-select :items="dependencias.necessidades_especiais"
                              v-model="data.necessidade.ref_necessidade_especial"
                              :error-messages="necessidadeEspecialErros"
                              @input="$v.data.necessidade.ref_necessidade_especial.$touch()"
                              @blur="$v.data.necessidade.ref_necessidade_especial.$touch()"
                              label="Selecione uma Necessidade Especial"
                              item-text="descricao"
                              item-value="id"
                              single-line
                              clearable/>
                </v-flex>
                <v-flex sm6 xs12>
                    <v-text-field v-model="data.necessidade.necessidade_especial_compl"
                                  :error-messages="necessidadeEspecialComplementoErros"
                                  @input="$v.data.necessidade.necessidade_especial_compl.$touch()"
                                  @blur="$v.data.necessidade.necessidade_especial_compl.$touch()"
                                  label="Descrição"/>
                </v-flex>
                <v-flex sm4 xs12>
                    Permanente?
                    <v-radio-group v-model="data.necessidade.fl_permanente">
                        <v-radio label="Não" color="orange" :value="false"/>
                        <v-radio label="Sim" color="orange" :value="true"/>
                    </v-radio-group>
                </v-flex>
                <v-flex sm4 xs12>
                    Dificuldade ao acesso a alguns lugares?
                    <v-radio-group v-model="data.necessidade.fl_dificil_acesso">
                        <v-radio label="Não" color="orange" :value="false"/>
                        <v-radio label="Sim" color="orange" :value="true"/>
                    </v-radio-group>
                </v-flex>
                <v-flex sm4 xs12>
                    Necessita acompanhamento?
                    <v-radio-group v-model="data.necessidade.fl_necessita_acompanhamento">
                        <v-radio label="Não" color="orange" :value="false"/>
                        <v-radio label="Sim" color="orange" :value="true"/>
                    </v-radio-group>
                </v-flex>
            </v-layout>
            <v-btn color="success"
                   @click="salvarNecessidadeEspecial"
                   :disabled="botaoClicado || $v.data.necessidade.$invalid">
                <i class="fas fa-check"></i>
                <span class="pl-2">Salvar Dados</span>
            </v-btn>
            <v-btn @click="limparNecessidadeEspecial">
                <i class="fas fa-eraser"></i>
                <span class="pl-2">Limpar</span>
            </v-btn>
        </v-container>
        <v-divider></v-divider>
        <h3 class="my-special-needs">Necessidades Cadastradas</h3>
        <div class="responsive-table">
            <table class="v-table">
                <thead>
                <tr>
                    <th>Necessidade Especial</th>
                    <th>Descrição</th>
                    <th>Permanente</th>
                    <th>Dificuldade ao acesso a alguns lugares</th>
                    <th>Necessita acompanhamento</th>
                    <th align="center" width="140">Ações</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="item in data.necessidades_especiais">
                    <td>{{item.necessidade_especial.descricao}}</td>
                    <td>{{item.necessidade_especial_compl}}</td>
                    <td>{{item.fl_permanente ? 'Sim' : 'Não'}}</td>
                    <td>{{item.fl_dificil_acesso ? 'Sim' : 'Não'}}</td>
                    <td>{{item.fl_necessita_acompanhamento ? 'Sim' : 'Não'}}</td>
                    <td>
                        <v-btn fab small depressed color="info" title="Editar"
                               @click="editarNecessidadeEspecial(item)">
                            <i class="fas fa-edit"></i>
                        </v-btn>
                        <v-btn fab small depressed color="error" title="Remover"
                               @click="removerNecessidadeEspecial(item)">
                            <i class="fas fa-times"></i>
                        </v-btn>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
    </v-form>
</template>

<style>
    .my-special-needs {
        padding: 15px 0;
        font-weight: 500;
        font-size: 18px;
    }
</style>



// WEBPACK FOOTER //
// NecessidadesEspeciais.vue?bb94ac3c